import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Header.css';

const Header = () => {
  const [logoError, setLogoError] = useState(false);

  return (
    <motion.header 
      className="header"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="header-container">
        <motion.div 
          className="logo"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          {!logoError ? (
            <img 
              src="/images/logo.jpg" 
              alt="AirRoom" 
              className="logo-image"
              onError={() => setLogoError(true)}
            />
          ) : (
            <span className="logo-text">AirRoom</span>
          )}
          <span className="logo-subtitle">Vape Shop</span>
        </motion.div>
      </div>
    </motion.header>
  );
};

export default Header;

